/* Version: 3.5.155 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useRef } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon.js';
import TextLink from '../TextLink/index.js';
import { BREAKPOINTS } from '../../spacing/index.js';
import { rem } from '../../utils/functions.js';
import { QuickLinksSection, QuickLinksAccordionHeader, QuickLinksHeader, QuickLinksList } from './styledComponents.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useTheme from '../../hooks/useTheme.js';
import useMedia from '../../hooks/useMedia.js';
import useToggle from '../../hooks/useToggle.js';

var LinkDropdown = function LinkDropdown(_ref) {
  var id = _ref.id,
    title = _ref.title,
    _ref$links = _ref.links,
    links = _ref$links === undefined ? [] : _ref$links;
  var theme = useTheme();
  var toggleRef = useRef();
  var isCollapsible = useMedia(["(max-width: ".concat(BREAKPOINTS.TABLET_PORTRAIT, "px)")], [true], false);
  var _useToggle = useToggle(),
    _useToggle2 = _slicedToArray(_useToggle, 3),
    expanded = _useToggle2[0],
    toggleExpanded = _useToggle2[1],
    setExpanded = _useToggle2[2];
  function handleKeyDown(event) {
    if (event.key === 'Escape') {
      setExpanded(false);
      toggleRef.current.focus();
    }
  }
  return /*#__PURE__*/jsxs(QuickLinksSection, {
    theme: theme,
    children: [isCollapsible ? /*#__PURE__*/jsxs(QuickLinksAccordionHeader, {
      type: "button",
      onClick: toggleExpanded,
      className: "mux-Footer-accordion-header",
      "aria-expanded": expanded,
      "aria-haspopup": "true",
      "aria-controls": "".concat(id, "-list"),
      ref: toggleRef,
      theme: theme,
      children: [/*#__PURE__*/jsx(Icon, {
        manulifeName: expanded ? 'minus' : 'plus',
        alt: expanded ? 'collapse' : 'expand',
        fill: theme.colorPalette.neutralColors.light.shade_dark_3,
        width: rem(14),
        height: rem(14)
      }), title]
    }) : /*#__PURE__*/jsx(QuickLinksHeader, {
      theme: theme,
      children: title
    }), /*#__PURE__*/jsx(QuickLinksList, {
      id: "".concat(id, "-list"),
      "data-testid": "quick-links-list",
      onKeyDown: handleKeyDown,
      children: (expanded || !isCollapsible) && links.map(function (link) {
        var textLinkProps;
        if (link.onClick) {
          textLinkProps = {
            as: 'button',
            onClick: link.onClick
          };
        } else {
          textLinkProps = {
            to: link.href
          };
        }
        return /*#__PURE__*/jsx("li", {
          "data-testid": "quick-links-item-".concat(link.id),
          children: /*#__PURE__*/jsx(TextLink, _objectSpread(_objectSpread({
            id: "".concat(id, "-").concat(link.id),
            variant: TextLink.VARIANT.INVERSE,
            isExternal: link.isExternal
          }, textLinkProps), {}, {
            children: link.title
          }))
        }, link.id);
      })
    })]
  });
};
process.env.NODE_ENV !== "production" ? LinkDropdown.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    isExternal: PropTypes.bool,
    href: PropTypes.string,
    onClick: PropTypes.func
  }))
} : undefined;
process.env.NODE_ENV !== "production" ? LinkDropdown.displayName = 'LinkDropdown' : undefined;

export { LinkDropdown as default };
